<template>
  <div class="form-group">
    <legend><em class="fa fa-users"></em> Approval Information</legend>
    <div class="table-responsive">
      <table class="table table-hover table-striped" aria-label="List Supervisor">
        <thead>
        <tr>
          <th style="min-width:10px" id="level"> Level </th>
          <th id="name"> Name </th>
          <th id="email"> Email </th>
        </tr>
        </thead>
        <tbody >
        <tr v-for="(data, i) in list_supervisor">
          <td>{{data.grade}}</td>
          <td>{{data.name}}</td>
          <td>{{data.email}}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";

export default {
  name: "ListSupervisor",
  data(){
    return {
      list_supervisor:[]
    }
  },
  props:{
    module:{
      type:String
    }
  },
  watch:{
    module(){
      // this.getListSupervisor()
    }
  },
  methods:{
    getListSupervisor(){
      let payload = {
        module:this.module
      }

      AxiosCall.Get(payload, urlApi.employee.list_supervisor).then(res=>{
        if(res.success){
          this.list_supervisor = res.atributes
        }else {
          this.$root.$children[0].errorMessage(res.message)
        }
      }).catch(e=>{
        this.$root.$children[0].errorMessage(e.response.data.message)
      })
    },
    setListSupervisor(){
      setTimeout(()=>{
        this.getListSupervisor()
      }, 100)
    }
  },
  mounted() {
    if(this.module !== undefined) this.setListSupervisor()
  },
}
</script>